import { AxiosResponse } from "axios"
import { axiosInstance } from "./common"
import { CaseNoteType } from "./CaseNote"

export enum ContentType {
    BRIEF_BACKGROUND = "brief_background",
    DOCUMENT_VERIFICATION = "document_verification",
    CASE_DETAILS_SUMMARY = "case_details_summary",
    DEFAULT = "default_prompt",
    ADDITIONAL_ANALYSIS = "additional_analysis",
    // PORTFOLIO_ANALYSIS = "portfolio_analysis",
    // INTERVIEW_FINDINGS = "interview_findings"
    // 4th July, 2025 - Commented out since these enums, when used, return "No data available etc" on Generate with AI,
    // despite the CPlane service having these Enum entries.
}

export interface ContentRequest {
    type: ContentType
    existing_content?: string
    context: {[key: string]: any}
}

export interface ContentResponse {
    content: string
}

export enum GenerateContentType {
  CASE_OVERVIEW = "CASE_OVERVIEW",
  BORROWER_VERIFICATIONS = "BORROWER_VERIFICATIONS",
  PORTFOLIO_ANALYSIS = "PORTFOLIO_ANALYSIS",
  INTERVIEW_FINDINGS = "INTERVIEW_FINDINGS",
  COLLATERAL_VERIFICATIONS = "COLLATERAL_VERIFICATIONS",
  ADDITIONAL_ANALYSIS = "ADDITIONAL_ANALYSIS",
}

export const contentTypeMap: Record<CaseNoteType, GenerateContentType> = {
    case_details: GenerateContentType.CASE_OVERVIEW,
    profile_verification: GenerateContentType.BORROWER_VERIFICATIONS,
    portfolio_analysis: GenerateContentType.PORTFOLIO_ANALYSIS,
    interview_findings: GenerateContentType.INTERVIEW_FINDINGS,
    collateral_verification: GenerateContentType.COLLATERAL_VERIFICATIONS,
    additional_analysis: GenerateContentType.ADDITIONAL_ANALYSIS,
};

export interface ImproveContentRequest {
    content: string;
};

const ContentAPI = {
    create: async (request: ContentRequest) => {
        const response: AxiosResponse<ContentResponse> = await axiosInstance.post('/v1/create-content', request);
        return response.data;
    },
    
    generate: async (caseId: string, contentType: GenerateContentType) => {
        const response: AxiosResponse<ContentResponse> = await axiosInstance.get(
            `/v1/cases/${caseId}/generate-content/${contentType}`
        );
        return response.data;
    },

    improve: async (request: ImproveContentRequest) => {
    const response: AxiosResponse<ContentResponse> =
      await axiosInstance.post("/v1/improve-content", request);
    return response.data;
    },
    
}

export default ContentAPI;